module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/icon-默认图标-用户.8ef8c.png";